// Web Push helpers — VAPID subscribe/unsubscribe + service worker registration.
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const isPushSupported = () =>
  'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;

export const getPermissionState = () => (isPushSupported() ? Notification.permission : 'unsupported');

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = atob(base64);
  return Uint8Array.from([...rawData].map((c) => c.charCodeAt(0)));
}

export async function registerPushServiceWorker() {
  if (!isPushSupported()) return null;
  return navigator.serviceWorker.register('/push-sw.js');
}

export async function subscribeToPush(token) {
  if (!isPushSupported()) throw new Error('Push notifications are not supported in this browser');

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') throw new Error('Notification permission denied');

  const registration = await registerPushServiceWorker();
  await navigator.serviceWorker.ready;

  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    const { data } = await axios.get(`${API}/push/vapid-public-key`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.publicKey),
    });
  }

  const subJson = subscription.toJSON();
  await axios.post(
    `${API}/push/subscribe`,
    { endpoint: subJson.endpoint, keys: subJson.keys, user_agent: navigator.userAgent },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return subscription;
}

export async function unsubscribeFromPush(token) {
  if (!isPushSupported()) return;
  const registration = await navigator.serviceWorker.getRegistration('/push-sw.js');
  if (!registration) return;
  const subscription = await registration.pushManager.getSubscription();
  if (!subscription) return;

  await axios.post(
    `${API}/push/unsubscribe`,
    { endpoint: subscription.endpoint },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  await subscription.unsubscribe();
}
